import React from "react"
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import googleplaybutton from '../../../assets/images/google_play.png';

import { connect } from 'react-redux';
import { getAboutInfo } from '../../../redux/actions'

const AboutInfo = (props) => {
    const { getAboutInfoAction, getAboutInfoList, loading, error, messages } = props
    // const [AboutInfoData, setAboutInfoData] = useState([])
  
    console.log("check---", getAboutInfoList, loading, error, messages)
  
    React.useEffect(() => {
      // alert('calld')
      fetchData()
    }, [])
  
    const fetchData = () => {
      // alert("hello")
      getAboutInfoAction(1)
    }
    const regex = /(<([^>]+)>)/ig;
    const secondRegEx = /((&nbsp;))*/gmi;

    return (
        <>
        <section className="aboutskycars-wrap pt-100 pb-70">
            {getAboutInfoList.length > 0
            ?
            <Container>
                <Row>
                {getAboutInfoList && getAboutInfoList.map((item) => (
                    <Col md={12}>
                        <div className="aboutskycars-listing">
                       
                            <h2>{item.Title}</h2>
                            <p>{item.Content.replace(regex, '').replace(secondRegEx, '')}</p>
                        </div>
                       
                    </Col>           
                    ))}
                </Row>
                <Row>
                    <Col md={12}>
                        <div className="app-bg-wrap">
                            <div className="app-bg-inner">
                                <h2>Get 50% Off on your first download and book trip.</h2>
                                <p>Rent your first car for 50% off offer signing up for the first time via app.</p>
                                <Link to=""><img src={googleplaybutton} alt="" /></Link>
                            </div>
                        </div>
                    </Col>
                    
                </Row>
            </Container>     
            : <Container>

            </Container>
            }       
        </section>
        </>
    ); 
  }
  //   export default AboutInfo;
const mapStateToProps = ({ aboutinfo }) => {
    // console.log('======', howitwork);
    const { loading, error, messages, getAboutInfoList } = aboutinfo;
    return { loading, error, messages, getAboutInfoList };
  };
  
  export default connect(mapStateToProps, {
    getAboutInfoAction: getAboutInfo,
  })(AboutInfo);
  